<template>
    <div class="serBrand" style="height:100%" v-if="cityList.length==0">
        <Loding></Loding>
    </div>
    <div class="serBrand" v-else>
        <van-panel class="serBrand-hot">
            <div slot="header" class="serBrand-title">
                <div style="color:#323233">热门城市</div>
                <div style="color:#F1452F" @click="cancel">关闭</div>
            </div>
           <span v-for="item in hotList" @click="toBrand(item)" :class="{'anchor-click' : item.is_click == 1}">{{item.title}}</span>
        </van-panel>
        
        <div class="serBrand-list">
            <van-index-bar :sticky="false" highlight-color="#f1452f">
                <van-index-anchor class="serBrand_cell" v-for="(item,index) in firstName" :key="index" :index="index">
                    <span class="color_f145">{{index}}</span>
                    <van-cell v-for="(citem,cindex) in item" :key="cindex" @click="toBrand(citem)">
                        <div slot="default"
                            :class="{'anchor-click' : citem.is_click == 1,'anchor-none' : citem.is_click == 0}">
                            {{citem.title}}</div>
                    </van-cell>
                </van-index-anchor>
            </van-index-bar>
        </div>
    </div>
</template>

<script>
    import Loding from '@/components/loding'

    export default {
        data() {
            return {
                FirstPin: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T",
                    "U", "V", "W", "X", "Y", "Z"
                ],
                cityList: [],
                cityNameList: [],
                firstName: {},
                hotList: []
            }
        },
        components: {
            Loding
        },
        created() {
            this.getData();
        },
        methods: {
            getData() {
                //品牌列表
                this.$axios.post(baseUrl + '/mobile/Index/city').then((res) => {
                    if (res.data.code == 2) {
                        this.cityList = res.data.data.data
                        this.hotList = res.data.data.is_hot
                        for (let p in this.cityList) {
                            this.cityNameList.push({
                                title: this.cityList[p].title,
                                id: this.cityList[p].id,
                                is_click: this.cityList[p].is_click
                            })
                        };
                        let pinyin = require('js-pinyin')
                        pinyin.setOptions({
                            checkPolyphone: false,
                            charCase: 0
                        });
                        this.FirstPin.forEach((item) => {
                            this.firstName[item] = [];
                            this.cityNameList.forEach((el) => {
                                let first = pinyin.getFullChars(el.title).substring(0, 1);
                                if (first == item) {
                                    this.firstName[item].push({
                                        title: el.title,
                                        id: el.id,
                                        is_click: el.is_click
                                    })
                                }
                            })
                        });
                        this.$forceUpdate();
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            //选择城市
            toBrand(el) {
                if (el.is_click == 0) {
                    this.$emit('title', el.title);
                    this.$emit('close', false);
                }
            },
            //点击关闭
            cancel() {
                this.$emit('close', false)
            }
        }
    }
</script>

<style scoped>
    .serBrand {
        text-align: left;
        background: #fff;
    }

    .serBrand .serBrand-list {
        position: absolute;
        width: 100%;
        top: 5.5rem;
        bottom: 0;
        right: 0;
        left: 0;
        overflow-y: scroll;
    }

    .serBrand .van-panel .van-panel__content {
        padding: 1rem 0.5rem;
        display: flex;
        justify-content: space-around;
        font-size: 0.8rem;
        font-size: #555;
        border-bottom: 1px solid #ebedf0;
    }

    .serBrand .serBrand-title {
        display: flex;
        justify-content: space-between;
        padding: 0.5rem;
        font-size: 0.85rem;
        border-bottom: 1px solid #ebedf0;
    }

    .serBrand .van-panel .van-panel__content img {
        width: 100%;
        max-height: 3rem;
    }

    .border-bottom {
        border-bottom: 1px solid #efefef;
    }

    .border-lr {
        border-left: 1px solid #efefef;
        border-right: 1px solid #efefef;
    }

    .van-index-anchor .van-cell__title img {
        width: 6.2rem;
        height: 2rem;
        object-fit: cover;
    }

    .van-index-anchor .van-cell__value {
        text-align: left;
        display: flex;
        align-items: center;
        font-size: 0.75rem;
    }

    .van-index-anchor .color_f145 {
        color: #F1452F;
        display: inline-block;
        padding-left: 1rem;
        width: 100%;
        box-sizing: border-box;
        background: -webkit-linear-gradient(left, #f4f5f7, #fff);
    }

    .anchor-click {
        color: #b1b1b1;
    }

    .anchor-none {
        color: #555;
    }
</style>


// WEBPACK FOOTER //
// src/components/address.vue